import axios from 'axios';

const API = '/api';

const getAuthHeader = () => {
  const token = sessionStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Auth
  login: (username, password) => 
    axios.post(`${API}/auth/login`, { username, password }, { withCredentials: false }),
  
  logout: () => 
    axios.post(`${API}/auth/logout`, {}, { withCredentials: false }),
  
  getMe: () => 
    axios.get(`${API}/auth/me`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),

  // Year management
  getAdminAvailableYears: () =>
    axios.get(`${API}/admin/available-years`, { headers: getAuthHeader(), withCredentials: false }),

  addAdminYear: (year) =>
    axios.post(`${API}/admin/available-years`, { year }, { headers: getAuthHeader(), withCredentials: false }),

  getTeacherAvailableYears: () =>
    axios.get(`${API}/teacher/available-years`, { headers: getAuthHeader(), withCredentials: false }),

  confirmLessonsForYear: (data) =>
    axios.post(`${API}/admin/lessons/confirm-year`, data, { headers: getAuthHeader(), withCredentials: false }),

  copyStudentsToYear: (data) =>
    axios.post(`${API}/admin/students/copy-to-year`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Admin - Teachers
  getTeachers: () => 
    axios.get(`${API}/admin/teachers`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  createTeacher: (data) => 
    axios.post(`${API}/admin/teachers`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  updateTeacher: (id, data) => 
    axios.put(`${API}/admin/teachers/${id}`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  deleteTeacher: (id) => 
    axios.delete(`${API}/admin/teachers/${id}`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),

  importTeachers: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/teachers/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  importCollaborators: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/collaborators/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  importOthers: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/others/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  // Teacher - Students
  getStudents: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/students${qs ? '?' + qs : ''}`, {
      headers: getAuthHeader(),
      withCredentials: false
    });
  },
  
  createStudent: (data) => 
    axios.post(`${API}/teacher/students`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  updateStudent: (studentId, data) =>
    axios.put(`${API}/teacher/students/${studentId}`, data, {
      headers: getAuthHeader(),
      withCredentials: false
    }),
  adminUpdateStudent: (studentId, data) =>
    axios.put(`${API}/admin/students/${studentId}`, data, {
      headers: getAuthHeader(),
      withCredentials: false
    }),

  deleteStudent: (id) => 
    axios.delete(`${API}/teacher/students/${id}`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),

  // Teacher - Lessons
  getLessons: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/lessons${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },
  
  createLesson: (data) => 
    axios.post(`${API}/teacher/lessons`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  updateLesson: (id, data) => 
    axios.put(`${API}/teacher/lessons/${id}`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  deleteLesson: (id) => 
    axios.delete(`${API}/teacher/lessons/${id}`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),

  // Availability
  getAvailability: () => 
    axios.get(`${API}/teacher/availability`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  updateAvailability: (data) => 
    axios.post(`${API}/teacher/availability`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),

  importStudentBirthdates: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/students/import-birthdates`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  // Import - Admin only
  importExcel: (teacherId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/import/${teacherId}`, formData, { 
      headers: { 
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data' 
      }, 
      withCredentials: false 
    });
  },

  // Attendance
  getAttendance: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    if (params.date) searchParams.append('date', params.date);
    if (params.date_from) searchParams.append('date_from', params.date_from);
    if (params.date_to) searchParams.append('date_to', params.date_to);
    if (params.week_start) searchParams.append('week_start', params.week_start);
    if (params.student_name) searchParams.append('student_name', params.student_name);
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/attendance${qs ? '?' + qs : ''}`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    });
  },
  
  createAttendance: (data) => 
    axios.post(`${API}/teacher/attendance`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  updateAttendance: (id, data) => 
    axios.put(`${API}/teacher/attendance/${id}`, data, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  getAttendanceStatusOptions: () => 
    axios.get(`${API}/teacher/attendance/status-options`, { 
      headers: getAuthHeader(), 
      withCredentials: false 
    }),
  
  importAttendance: (teacherId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/attendance/import/${teacherId}`, formData, { 
      headers: { 
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data' 
      }, 
      withCredentials: false 
    });
  },

  importAttendanceAll: (file, anno) => {
    const formData = new FormData();
    formData.append('file', file);
    if (anno) formData.append('anno', anno);
    return axios.post(`${API}/admin/attendance/import-all`, formData, { 
      headers: { 
        ...getAuthHeader(),
        'Content-Type': 'multipart/form-data' 
      }, 
      withCredentials: false 
    });
  },

  bulkCreateAttendance: (data) =>
    axios.post(`${API}/teacher/attendance/bulk`, data, { headers: getAuthHeader(), withCredentials: false }),

  updateAttendanceDetails: (id, data) =>
    axios.put(`${API}/teacher/attendance/${id}/details`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteAttendance: (id) =>
    axios.delete(`${API}/teacher/attendance/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  // Payments
  getPayments: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    if (params.month) searchParams.append('month', params.month);
    if (params.student_name) searchParams.append('student_name', params.student_name);
    if (params.status) searchParams.append('status', params.status);
    if (params.data_scadenza) searchParams.append('data_scadenza', params.data_scadenza);
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/payments${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getAdminPayments: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    if (params.anno) searchParams.append('anno', params.anno);
    if (params.anno_competenza) searchParams.append('anno_competenza', params.anno_competenza);
    if (params.month) searchParams.append('month', params.month);
    if (params.student_name) searchParams.append('student_name', params.student_name);
    if (params.status) searchParams.append('status', params.status);
    if (params.data_scadenza) searchParams.append('data_scadenza', params.data_scadenza);
    if (params.sort_by) searchParams.append('sort_by', params.sort_by);
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/payments${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  updateAdminPayment: (paymentId, data) =>
    axios.put(`${API}/admin/payments/${paymentId}`, data, { headers: getAuthHeader(), withCredentials: false }),

  assegnaRicevutaPayments: (payment_ids, nr_ricevuta, data_ricevuta) =>
    axios.post(`${API}/admin/payments/assegna-ricevuta`, { payment_ids, nr_ricevuta, data_ricevuta }, { headers: getAuthHeader(), withCredentials: false }),
  getAdminPaymentsByIds: (ids) =>
    axios.post(`${API}/admin/payments/by-ids`, { ids }, { headers: getAuthHeader(), withCredentials: false }),

  importPayments: (file, anno, replaceAll = false) => {
    const formData = new FormData();
    formData.append('file', file);
    if (anno) formData.append('anno', anno);
    if (replaceAll) formData.append('replace_all', 'true');
    return axios.post(`${API}/admin/payments/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },
  importStudentCodici: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/admin/students/import-codici`, fd, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false,
    });
  },

  // Receipts (Ricevute)
  getReceipts: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/receipts${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Teacher Email
  getTeacherEmailTemplates: () =>
    axios.get(`${API}/teacher/email-templates`, { headers: getAuthHeader(), withCredentials: false }),

  teacherSendEmail: (data) =>
    axios.post(`${API}/teacher/send-email`, data, { headers: getAuthHeader(), withCredentials: false }),

  teacherDuplicateLesson: (data) =>
    axios.post(`${API}/teacher/lessons/duplicate-to-year`, data, { headers: getAuthHeader(), withCredentials: false }),

  getTeacherEmailLog: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.page) sp.append('page', params.page);
    if (params.limit) sp.append('limit', params.limit);
    const qs = sp.toString();
    return axios.get(`${API}/teacher/email-log${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getAdminReceipts: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    if (params.anno) searchParams.append('anno', params.anno);
    if (params.anno_competenza) searchParams.append('anno_competenza', params.anno_competenza);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/receipts${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  importReceipts: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/receipts/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  updateReceiptAltro: (receiptId, altro) =>
    axios.patch(`${API}/admin/receipts/${receiptId}/altro`, { altro }, { headers: getAuthHeader(), withCredentials: false }),

  updateReceiptTotale: (receiptId, totale) =>
    axios.patch(`${API}/admin/receipts/${receiptId}/totale`, { totale }, { headers: getAuthHeader(), withCredentials: false }),

  updateReceiptDoc: (receiptId, data) =>
    axios.patch(`${API}/admin/receipts/${receiptId}/doc`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteReceipt: (receiptId) =>
    axios.delete(`${API}/admin/receipts/${receiptId}`, { headers: getAuthHeader(), withCredentials: false }),

  // Statistics
  getTeacherStatistics: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/statistics${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getTeacherAttendanceCounter: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/teacher/attendance-counter${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getAdminStatistics: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/statistics${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Admin - Lessons per teacher
  getAdminTeacherStudents: (teacherId) =>
    axios.get(`${API}/admin/teacher/${teacherId}/students`, { headers: getAuthHeader(), withCredentials: false }),

  getAdminTeacherLessons: (teacherId, params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/teacher/${teacherId}/lessons${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getLessonsDayView: (day, anno) => {
    const params = new URLSearchParams();
    params.append('day', day);
    if (anno) params.append('anno', anno);
    return axios.get(`${API}/admin/lessons/day-view?${params.toString()}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Portineria (public + admin config)
  getPortineriaConfig: () =>
    axios.get(`${API}/settings/portineria-config`, { headers: getAuthHeader(), withCredentials: false }),

  verifyPortineriaPassword: (password) =>
    axios.post(`${API}/public/portineria/verify`, { password }, { withCredentials: false }),

  getPortineriaDayView: (day, anno, password) => {
    const params = new URLSearchParams();
    params.append('day', day);
    if (anno) params.append('anno', anno);
    return axios.get(`${API}/public/portineria/day-view?${params.toString()}`, {
      headers: { 'X-Portineria-Password': password },
      withCredentials: false,
    });
  },

  createAdminTeacherLesson: (teacherId, data) =>
    axios.post(`${API}/admin/teacher/${teacherId}/lessons`, data, { headers: getAuthHeader(), withCredentials: false }),

  updateAdminTeacherLesson: (teacherId, lessonId, data) =>
    axios.put(`${API}/admin/teacher/${teacherId}/lessons/${lessonId}`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteAdminTeacherLesson: (teacherId, lessonId) =>
    axios.delete(`${API}/admin/teacher/${teacherId}/lessons/${lessonId}`, { headers: getAuthHeader(), withCredentials: false }),

  generateAttendanceFromLesson: (teacherId, lessonId, data) =>
    axios.post(`${API}/admin/teacher/${teacherId}/lessons/${lessonId}/generate-attendance`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Admin - Holidays (festività scolastiche + nazionali)
  getAdminHolidays: (anno) =>
    axios.get(`${API}/admin/holidays?anno=${anno}`, { headers: getAuthHeader(), withCredentials: false }),
  createAdminHoliday: (data) =>
    axios.post(`${API}/admin/holidays`, data, { headers: getAuthHeader(), withCredentials: false }),
  deleteAdminHoliday: (id) =>
    axios.delete(`${API}/admin/holidays/${id}`, { headers: getAuthHeader(), withCredentials: false }),
  importAdminHolidaysPdf: (anno, file, replace = false) => {
    const fd = new FormData();
    fd.append('anno', anno);
    fd.append('replace', replace ? 'true' : 'false');
    fd.append('file', file);
    return axios.post(`${API}/admin/holidays/import-pdf`, fd, { headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' }, withCredentials: false });
  },

  getAdminTeacherAvailability: (teacherId) =>
    axios.get(`${API}/admin/teacher/${teacherId}/availability`, { headers: getAuthHeader(), withCredentials: false }),

  updateAdminTeacherAvailability: (teacherId, data) =>
    axios.post(`${API}/admin/teacher/${teacherId}/availability`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Admin - Attendance
  getAdminAllStudents: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    if (params.anno) searchParams.append('anno', params.anno);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/students${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  createAdminStudent: (data, anno) =>
    axios.post(`${API}/admin/students${anno ? '?anno=' + anno : ''}`, data, { headers: getAuthHeader(), withCredentials: false }),

  updateAdminStudent: (studentId, data) =>
    axios.put(`${API}/admin/students/${studentId}`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteAdminStudent: (studentId, anno) =>
    axios.delete(`${API}/admin/students/${studentId}${anno ? '?anno=' + anno : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  // Booking invite (link personalizzato per alunno esistente)
  createStudentBookingToken: (studentId) =>
    axios.post(`${API}/admin/students/${studentId}/booking-token`, {}, { headers: getAuthHeader(), withCredentials: false }),
  sendStudentBookingInvite: (studentId) =>
    axios.post(`${API}/admin/students/${studentId}/send-booking-invite`, {}, { headers: getAuthHeader(), withCredentials: false }),
  bulkSendBookingInvite: (studentIds) =>
    axios.post(`${API}/admin/students/bulk-send-booking-invite`, { student_ids: studentIds }, { headers: getAuthHeader(), withCredentials: false }),
  getBookingPrefill: (token) =>
    axios.get(`${API}/public/booking-token/${token}`, { withCredentials: false }),

  getAdminAttendance: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    if (params.anno) searchParams.append('anno', params.anno);
    if (params.date_from) searchParams.append('date_from', params.date_from);
    if (params.date_to) searchParams.append('date_to', params.date_to);
    if (params.student_name) searchParams.append('student_name', params.student_name);
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/attendance${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  updateAdminAttendance: (id, data) =>
    axios.put(`${API}/admin/attendance/${id}`, data, { headers: getAuthHeader(), withCredentials: false }),
  updateAdminAttendanceDetails: (id, data) =>
    axios.put(`${API}/admin/attendance/${id}/details`, data, { headers: getAuthHeader(), withCredentials: false }),
  createAdminAttendance: (data) =>
    axios.post(`${API}/admin/attendance`, data, { headers: getAuthHeader(), withCredentials: false }),
  deleteAdminAttendance: (id) =>
    axios.delete(`${API}/admin/attendance/${id}`, { headers: getAuthHeader(), withCredentials: false }),
  fixAdminAttendanceAnno: () =>
    axios.post(`${API}/admin/attendance/fix-anno`, {}, { headers: getAuthHeader(), withCredentials: false }),

  getAttendanceCounter: (params = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') searchParams.append(k, v); });
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/attendance/counter${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  deleteAttendanceByYear: (anno) =>
    axios.delete(`${API}/admin/attendance/year/${anno}`, { headers: getAuthHeader(), withCredentials: false }),

  fixAttendanceAnnoFromDate: () =>
    axios.post(`${API}/admin/attendance/fix-anno-from-date`, {}, { headers: getAuthHeader(), withCredentials: false }),

  // Admin - Lesson History
  getLessonHistory: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.teacher_id) searchParams.append('teacher_id', params.teacher_id);
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/lesson-history${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Email Templates
  getEmailTemplates: () =>
    axios.get(`${API}/admin/email-templates`, { headers: getAuthHeader(), withCredentials: false }),

  // Student Payment Summary
  getStudentsPaymentSummary: (anno) =>
    axios.get(`${API}/admin/students/payment-summary${anno ? '?anno=' + anno : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  getStudentPayments: (studentId, anno) =>
    axios.get(`${API}/admin/students/${studentId}/payments${anno ? '?anno=' + anno : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  downloadEstrattoContoSelective: (studentId, payment_ids) =>
    axios.post(`${API}/admin/students/${studentId}/estratto-conto-pdf-selective`, { payment_ids }, { headers: getAuthHeader(), withCredentials: false, responseType: 'blob' }),

  createEmailTemplate: (formData) =>
    axios.post(`${API}/admin/email-templates`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    }),

  seedConfermaTemplate: () =>
    axios.post(`${API}/admin/email-templates/seed-conferma`, {}, { headers: getAuthHeader(), withCredentials: false }),
  seedConfermaIscrizioneAccademiaTemplate: () =>
    axios.post(`${API}/admin/email-templates/seed-conferma-iscrizione-accademia`, {}, { headers: getAuthHeader(), withCredentials: false }),
  seedInvitoPrenotazioneTemplate: () =>
    axios.post(`${API}/admin/email-templates/seed-invito-prenotazione`, {}, { headers: getAuthHeader(), withCredentials: false }),
  seedConfermaPrenotazioneAccettataTemplate: () =>
    axios.post(`${API}/admin/email-templates/seed-conferma-prenotazione-accettata`, {}, { headers: getAuthHeader(), withCredentials: false }),
  seedSystemTemplates: () =>
    axios.post(`${API}/admin/email-templates/seed-system-templates`, {}, { headers: getAuthHeader(), withCredentials: false }),

  updateEmailTemplate: (templateId, formData) =>
    axios.put(`${API}/admin/email-templates/${templateId}`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    }),

  deleteEmailTemplate: (templateId) =>
    axios.delete(`${API}/admin/email-templates/${templateId}`, { headers: getAuthHeader(), withCredentials: false }),

  getLessonConfirmations: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.source_year) sp.append('source_year', params.source_year);
    if (params.target_year) sp.append('target_year', params.target_year);
    const qs = sp.toString();
    return axios.get(`${API}/admin/lesson-confirmations${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  deleteLessonConfirmation: (id) =>
    axios.delete(`${API}/admin/lesson-confirmations/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  updateConfirmationPaymentStatus: (id, payment_status) =>
    axios.put(`${API}/admin/lesson-confirmations/${id}/payment-status`, { payment_status }, { headers: getAuthHeader(), withCredentials: false }),

  downloadBonifico: (id) =>
    axios.get(`${API}/admin/lesson-confirmations/${id}/bonifico`, { headers: getAuthHeader(), withCredentials: false, responseType: 'blob' }),

  uploadBonifico: (token, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/public/confirm/${token}/bonifico`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: false,
    });
  },

  deleteAllLessonConfirmations: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.source_year) sp.append('source_year', params.source_year);
    if (params.status) sp.append('status', params.status);
    const qs = sp.toString();
    return axios.delete(`${API}/admin/lesson-confirmations${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Send Email
  sendEmail: (data) =>
    axios.post(`${API}/admin/send-email`, data, { headers: getAuthHeader(), withCredentials: false }),

  previewEmail: (data) =>
    axios.post(`${API}/admin/preview-email`, data, { headers: getAuthHeader(), withCredentials: false }),

  sendEmailToTeacher: (data) =>
    axios.post(`${API}/admin/send-email-teacher`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Email Log
  getEmailLog: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page);
    if (params.limit) searchParams.append('limit', params.limit);
    if (params.search) searchParams.append('search', params.search);
    const qs = searchParams.toString();
    return axios.get(`${API}/admin/email-log${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  getAccessLog: (params = {}) => {
    const q = new URLSearchParams();
    if (params.limit) q.append('limit', params.limit);
    if (params.search) q.append('search', params.search);
    if (params.only_failed) q.append('only_failed', 'true');
    const qs = q.toString();
    return axios.get(`${API}/admin/access-log${qs ? '?' + qs : ''}`, { headers: getAuthHeader(), withCredentials: false });
  },

  // Estratto Conto PDF
  downloadEstrattoConto: (studentId) =>
    axios.get(`${API}/admin/students/${studentId}/estratto-conto-pdf`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  teacherDownloadEstrattoConto: (studentId) =>
    axios.get(`${API}/teacher/students/${studentId}/estratto-conto-pdf`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  // Teacher Documents (Admin)
  getTeacherDocuments: (teacherId) =>
    axios.get(`${API}/admin/teachers/${teacherId}/documents`, { headers: getAuthHeader(), withCredentials: false }),

  uploadTeacherDocument: (teacherId, formData) =>
    axios.post(`${API}/admin/teachers/${teacherId}/documents`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    }),

  deleteTeacherDocument: (teacherId, docId) =>
    axios.delete(`${API}/admin/teachers/${teacherId}/documents/${docId}`, { headers: getAuthHeader(), withCredentials: false }),

  notifyTeacherDocuments: (teacherId, data) =>
    axios.post(`${API}/admin/teachers/${teacherId}/documents/notify`, data, {
      headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
      withCredentials: false
    }),

  downloadAdminDocument: (docId) =>
    axios.get(`${API}/admin/teachers/documents/download/${docId}`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  // Teacher Documents (Teacher side)
  getMyDocuments: () =>
    axios.get(`${API}/teacher/documents`, { headers: getAuthHeader(), withCredentials: false }),

  getAllStudentsForLesson: () =>
    axios.get(`${API}/teacher/all-students`, { headers: getAuthHeader(), withCredentials: false }),

  downloadMyDocument: (docId) =>
    axios.get(`${API}/teacher/documents/download/${docId}`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  // Company Settings
  getCompanySettings: () =>
    axios.get(`${API}/settings/company`, { withCredentials: false }),

  getAppVersion: () =>
    axios.get(`${API}/settings/version`, { withCredentials: false }),

  forgotPassword: (username) =>
    axios.post(`${API}/auth/forgot-password`, { username }, { withCredentials: false }),

  updateCompanySettings: (data) =>
    axios.put(`${API}/settings/company`, data, { headers: getAuthHeader(), withCredentials: false }),

  uploadCompanyLogo: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/settings/company/logo`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  // Export Codes
  exportStudentCodes: () =>
    axios.get(`${API}/admin/students/export-codes`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  exportTeacherCodes: () =>
    axios.get(`${API}/admin/teachers/export-codes`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob'
    }),

  downloadPaymentsEstrattoContoPdf: (params) =>
    axios.get(`${API}/admin/payments/estratto-conto-pdf`, {
      headers: getAuthHeader(), withCredentials: false, responseType: 'blob', params
    }),

  // Bookings (admin)
  getBookings: (stato) =>
    axios.get(`${API}/admin/bookings${stato ? `?stato=${stato}` : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  updateBooking: (id, data) =>
    axios.put(`${API}/admin/bookings/${id}`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteBooking: (id) =>
    axios.delete(`${API}/admin/bookings/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  resendBookingConfirmation: (id, template_name) =>
    axios.post(`${API}/admin/bookings/${id}/resend-confirmation`, { template_name }, { headers: getAuthHeader(), withCredentials: false }),

  setBookingProva: (id, is_prova) =>
    axios.put(`${API}/admin/bookings/${id}/prova`, { is_prova }, { headers: getAuthHeader(), withCredentials: false }),

  clearStudentProva: (student_id) =>
    axios.post(`${API}/admin/students/${student_id}/clear-prova`, {}, { headers: getAuthHeader(), withCredentials: false }),

  setStudentStatus: (student_id, target, anno) =>
    axios.post(`${API}/admin/students/${student_id}/set-status`, { target, anno }, { headers: getAuthHeader(), withCredentials: false }),

  sendLessonStartEmail: (payload) =>
    axios.post(`${API}/admin/students/send-lesson-start-email`, payload, { headers: getAuthHeader(), withCredentials: false }),

  previewLessonStartEmail: (payload) =>
    axios.post(`${API}/admin/students/preview-lesson-start-email`, payload, { headers: getAuthHeader(), withCredentials: false }),

  // Public
  getPublicInstruments: () =>
    axios.get(`${API}/public/instruments`, { withCredentials: false }),

  getPublicAvailability: (teacherId, anno) =>
    axios.get(`${API}/public/availability/${teacherId}?anno=${anno}`, { withCredentials: false }),

  createBooking: (data) =>
    axios.post(`${API}/public/booking`, data, { withCredentials: false }),

  // Potential Students
  getPotentialStudents: () =>
    axios.get(`${API}/admin/potential-students`, { headers: getAuthHeader(), withCredentials: false }),

  createPotentialStudent: (data) =>
    axios.post(`${API}/admin/potential-students`, data, { headers: getAuthHeader(), withCredentials: false }),

  updatePotentialStudent: (id, data) =>
    axios.put(`${API}/admin/potential-students/${id}`, data, { headers: getAuthHeader(), withCredentials: false }),

  deletePotentialStudent: (id) =>
    axios.delete(`${API}/admin/potential-students/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  makePotentialEffective: (id) =>
    axios.post(`${API}/admin/potential-students/${id}/make-effective`, {}, { headers: getAuthHeader(), withCredentials: false }),

  importPotentialStudents: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/admin/potential-students/import`, formData, {
      headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' },
      withCredentials: false
    });
  },

  sendEmailPotential: (data) =>
    axios.post(`${API}/admin/potential-students/send-email`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Instagram Posts
  getInstagramPostsAdmin: () =>
    axios.get(`${API}/admin/instagram-posts`, { headers: getAuthHeader(), withCredentials: false }),

  addInstagramPost: (data) =>
    axios.post(`${API}/admin/instagram-posts`, data, { headers: getAuthHeader(), withCredentials: false }),

  // Listini (Price Lists)
  getListini: (anno) =>
    axios.get(`${API}/admin/listini${anno ? '?anno=' + anno : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  getStudentLessonsWithListino: (studentId, anno) =>
    axios.get(`${API}/admin/students/${studentId}/lessons-with-listino${anno ? '?anno=' + anno : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  setLessonListino: (lessonId, listinoId) =>
    axios.put(`${API}/admin/lessons/${lessonId}/listino`, { listino_id: listinoId }, { headers: getAuthHeader(), withCredentials: false }),

  setLessonOrarioStatus: (lessonId, orarioStatus) =>
    axios.put(`${API}/admin/lessons/${lessonId}/orario-status`, { orario_status: orarioStatus }, { headers: getAuthHeader(), withCredentials: false }),

  setLessonStatusFlag: (lessonId, flag, value) =>
    axios.put(`${API}/admin/lessons/${lessonId}/status-flag`, { flag, value }, { headers: getAuthHeader(), withCredentials: false }),

  getIncongruenze: (anno) =>
    axios.get(`${API}/admin/incongruenze${anno ? `?anno=${anno}` : ''}`, { headers: getAuthHeader(), withCredentials: false }),

  setLessonProva: (lessonId, is_prova) =>
    axios.put(`${API}/admin/lessons/${lessonId}/prova`, { is_prova }, { headers: getAuthHeader(), withCredentials: false }),

  backfillLessonProva: () =>
    axios.post(`${API}/admin/lessons/backfill-prova`, {}, { headers: getAuthHeader(), withCredentials: false }),

  teacherSetLessonProva: (lessonId, is_prova) =>
    axios.put(`${API}/lessons/${lessonId}/prova`, { is_prova }, { headers: getAuthHeader(), withCredentials: false }),

  compareTeacherStudentsYears: (teacherId, sourceYear, targetYear) =>
    axios.get(`${API}/admin/teacher/${teacherId}/students-comparison?source_year=${sourceYear}&target_year=${targetYear}`, { headers: getAuthHeader(), withCredentials: false }),

  createListino: (data) =>
    axios.post(`${API}/admin/listini`, data, { headers: getAuthHeader(), withCredentials: false }),

  updateListino: (id, data) =>
    axios.put(`${API}/admin/listini/${id}`, data, { headers: getAuthHeader(), withCredentials: false }),

  deleteListino: (id) =>
    axios.delete(`${API}/admin/listini/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  deleteInstagramPost: (id) =>
    axios.delete(`${API}/admin/instagram-posts/${id}`, { headers: getAuthHeader(), withCredentials: false }),

  getInstagramPostsPublic: () =>
    axios.get(`${API}/public/instagram-posts`),
};

export default api;
